/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for CountryResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetCountrySelectResponse, GetCountryDetailsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CountryResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getCountrySelect(resourceOptions: HttpResourceOptions<GetCountrySelectResponse, unknown> & { defaultValue: NoInfer<GetCountrySelectResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCountrySelectResponse>;
    getCountrySelect(resourceOptions?: HttpResourceOptions<GetCountrySelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCountrySelectResponse | undefined>;
    getCountrySelect(resourceOptions?: HttpResourceOptions<GetCountrySelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCountrySelectResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Country/Select`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getCountryDetails(isoCode: Signal<string> | string, resourceOptions: HttpResourceOptions<GetCountryDetailsResponse, unknown> & { defaultValue: NoInfer<GetCountryDetailsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCountryDetailsResponse>;
    getCountryDetails(isoCode: Signal<string> | string, resourceOptions?: HttpResourceOptions<GetCountryDetailsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCountryDetailsResponse | undefined>;
    getCountryDetails(isoCode: Signal<string> | string, resourceOptions?: HttpResourceOptions<GetCountryDetailsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCountryDetailsResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Country/${typeof isoCode === 'function' ? isoCode() : isoCode}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
